<template>
  <div class="flex flex-col py-4 bg-white mb-4">
    <vs-col vs-w="12" vs-type="flex" vs-align="center" vs-justify="space-between">
      <div class="flex">
        <feather-icon
          class="mr-2"
          icon="FileTextIcon"
          svgClasses="text-black stroke-current w-36.96 h-36.96"
        ></feather-icon>
        <h4>Informações Básicas</h4>
      </div>

      <vs-button
        class="ml-2 mobile-hidden"
        size="small" 
        color="primary"
        type="border"
        icon="edit"
        @click="navigateToSelectedStep">
        Editar
      </vs-button>

      <vs-button
        class="ml-2 sm:hidden"
        size="small" 
        color="primary"
        type="border"
        icon="edit"
        @click="navigateToSelectedStep"
      />
    </vs-col>

    <hr class="my-4 line"/>

    <div class="flex">
      <div v-if="show()" class="flex flex-col">

        <ul class="activity-timeline mobile-hidden">
          <li>

            <div class="timeline-icon" :style="{backgroundColor: color}" key="timeline-basicInfo">
              <feather-icon icon="FileTextIcon" svgClasses="text-white stroke-current w-5 h-5"></feather-icon>
            </div>

              <div class="flex pl-1 my-1" v-if="email != ''">
                <p><b>E-mail:</b> {{ email }}</p>
              </div>

              <div class="flex pl-1 my-1" v-if="telephone != ''">
                <p><b>Telefone:</b> {{ telephone }}</p>
              </div>

              <div class="flex pl-1 my-1" v-if="birthday != ''">
                <p><b>Data de nascimento:</b> {{ birthday }}</p>
              </div>

              <div class="flex pl-1 my-1" v-if="ssn != ''">
                <p><b>CPF:</b> {{ ssn }}</p>
              </div>
          </li>
        </ul>

        <div class="sm:hidden">

          <div class="flex pl-1 my-1" v-if="email != ''">
            <p><b>E-mail:</b> {{ email }}</p>
          </div>

          <div class="flex pl-1 my-1" v-if="telephone != ''">
            <p><b>Telefone:</b> {{ telephone }}</p>
          </div>

          <div class="flex pl-1 my-1" v-if="birthday != ''">
            <p><b>Data de nascimento:</b> {{ birthday }}</p>
          </div>

          <div class="flex pl-1 my-1" v-if="ssn != ''">
            <p><b>CPF:</b> {{ ssn }}</p>
          </div>
        </div>

      </div>
      <EmptyDetailCard
        v-else
        description="Você ainda não preencheu nenhuma informação básica..."
      />
    </div>
  </div>
</template>


<script>
import { differenceInYears } from 'date-fns'
import { mapState, mapActions } from 'vuex'

import EmptyDetailCard from '@/components/dashboard/profile-detail/EmptyDetailCard'

export default {
  name: 'simple-basic-info',
  computed: {
    ...mapState('basicInfo', ['basicInfo']),
    ...mapState('company', ['company']),

    computedBorn() {
      const splited = this.basicInfo.birthday.split('/')
      return differenceInYears(new Date(splited[2], splited[1] -1, splited[0]), new Date())
    },

    email() {
      return this.basicInfo != undefined ? this.basicInfo.email : '' 
    },

    telephone() {
      return this.basicInfo != undefined ? this.basicInfo.telephone : '' 
    },

    birthday() {
      return this.basicInfo != undefined ? this.basicInfo.birthday : '' 
    },

    ssn() {
      return this.basicInfo != undefined ? this.basicInfo.ssn : '' 
    },

    maritalStatus() {
      return this.basicInfo != undefined ? this.basicInfo.marital_status : '' 
    },

    gender() {
      return this.basicInfo != undefined || this.basicInfo !== null ?
      (this.basicInfo.gender == 0 ? 'Masculino' : (this.basicInfo.gender == 1) ? 'Feminino' : 'Outro') :
      ''
    },

    pcd() {
      return this.basicInfo && this.basicInfo.hasOwnProperty('pcd') ? this.basicInfo.pcd : ''
    },

    color() {
      return this.company.base_hexcolor || '#1551b1'
    }
  },
  methods: {
    navigateToSelectedStep() {
      this.updateCurrentStep({ order: 1 })
      this.$router.push({ name: 'step-basic-info' })
    },

    show() {
      return Object.keys(this.basicInfo).length > 0
    },

    ...mapActions('step', ['updateCurrentStep'])
  },
  components: { EmptyDetailCard }
}
</script>

<style lang="scss" scoped>
hr{
    height: 1px;
    background-color: rgba(0, 0, 0, 0.1);
    border: none;
}
</style>